var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconYoutube = function SvgIconYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.67 9.179s-.312-2.353-1.271-3.389c-1.217-1.358-2.58-1.366-3.205-1.443C22.717 4 16.002 4 16.002 4h-.015s-6.715 0-11.191.347c-.625.077-1.987.085-3.205 1.443C.633 6.826.32 9.179.32 9.179S0 11.94 0 14.701v2.588c0 2.763.32 5.523.32 5.523s.312 2.352 1.271 3.386c1.218 1.358 2.815 1.317 3.527 1.459 2.559.262 10.877.343 10.877.343s6.722-.012 11.199-.355c.625-.08 1.988-.088 3.205-1.446.958-1.034 1.271-3.386 1.271-3.386s.32-2.761.32-5.523v-2.588c0-2.762-.32-5.523-.32-5.523z",
    fill: "#E02F2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M12 10v12l10-6z"
  })));
};
export default SvgIconYoutube;